import { render, staticRenderFns } from "./acciones_correctivas.vue?vue&type=template&id=532fdcb4&scoped=true"
import script from "./acciones_correctivas.vue?vue&type=script&lang=js"
export * from "./acciones_correctivas.vue?vue&type=script&lang=js"
import style0 from "./acciones_correctivas.vue?vue&type=style&index=0&id=532fdcb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532fdcb4",
  null
  
)

export default component.exports